module.exports = __webpack_public_path__ + "img/vip.bc3c1d19.png";